import { create } from "zustand";

type State = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
};

const useQuickStartStore = create<State>((set) => {
  // localStorage에서 값 읽기 (서버사이드 렌더링 환경에서는 window가 없으니 체크 필요)
  let isVisible = true;
  if (typeof window !== "undefined") {
    const isQuickStartClose = localStorage.getItem("quickStartClose");
    isVisible = isQuickStartClose !== "true";
  }
  return {
    isVisible,
    setIsVisible: (isVisible: boolean) => set({ isVisible }),
  };
});

export default useQuickStartStore;
